import ScenesListContainer from './ScenesList.container'

export default ScenesListContainer